import { createFileRoute } from '@tanstack/react-router';
import RequestDetailsPage from '../../../features/bed-management/pages/RequestDetailsPage';
import { getRequestQueryOptions } from '../../../features/bed-management/queries/get-request/get-request-query-options';

export const Route = createFileRoute('/_auth/bed-management/requests/$id')({
  loader: ({ context, params }) => {
    return context.queryClient.ensureQueryData(getRequestQueryOptions(params.id));
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  return <RequestDetailsPage requestId={id} />;
}
